import { render, staticRenderFns } from "./ClientTicketUpdate.vue?vue&type=template&id=323c8c3a&scoped=true&"
import script from "./ClientTicketUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientTicketUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c8c3a",
  null
  
)

export default component.exports